import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import FaqCard from 'components/FaqCard';
import { faqs } from 'utils/faq/homepage-faqs';
import styles from './FaqSection.module.css';

const FAQ_SECTION_TITLE = 'You might be wondering...';

export const FaqSection = () => {
  return (
    <AboutUsModule background={'white'}>
      <AboutUsSiteContainer>
        <div className={styles.container}>
          <h2
            data-text={FAQ_SECTION_TITLE}
            className={`aboutUsTypographyHeaderXlargeOnWhite`}
          >
            {FAQ_SECTION_TITLE}
          </h2>

          <div>
            {faqs.map((faq, index) => (
              <FaqCard
                key={index}
                question={faq.question}
                answer={faq.answer}
                rebrand2025
                withBorder
              />
            ))}
          </div>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
